import { DropdownHeaderPropsBase } from "@/components/common/dropdown/data/dropdown-button-data";
import DropdownHeaderWithIcon from "@/components/common/dropdown/headers/dropdown-header-with-icon";
import styles from "@/components/common/dropdown/styles/dropdown-default-icon-header.module.scss";
import dotsIcon from "@/assets/icons/dots-dropdown-icon.svg";

const DropdownDefaultIconHeader = ({
  params,
  handleClick,
}: DropdownHeaderPropsBase) => {
  return (
    <div
      className={styles.wrapper}
      style={{ backgroundColor: params.isOpen ? "#3F3F3F" : "transparent" }}
    >
      <DropdownHeaderWithIcon
        params={params}
        handleClick={handleClick}
        icon={dotsIcon}
        openedIcon={dotsIcon}
      />
    </div>
  );
};

export default DropdownDefaultIconHeader;
